
    import { defineComponent } from 'vue'
    import Checkbox from 'primevue/checkbox'
    import Dialog from 'primevue/dialog'
    import Listbox from 'primevue/listbox'
    import Message from 'primevue/message'
    import metawebAttributeUnusedFieldDialogDescriptor from './MetawebAttributeUnusedFieldDialogDescriptor.json'

    export default defineComponent({
        name: 'metaweb-attribute-detail-dialog',
        components: { Checkbox, Dialog, Listbox, Message },
        props: { visible: { type: Boolean }, unusedFields: { type: Object } },
        emits: ['close', 'save'],
        data() {
            return {
                metawebAttributeUnusedFieldDialogDescriptor,
                fields: [] as any[],
                selectedUnusedFields: [] as any[],
                loading: false
            }
        },
        watch: {
            unusedFields() {
                this.loadFields()
            }
        },
        created() {
            this.loadFields()
        },
        methods: {
            loadFields() {
                this.fields = this.unusedFields as any[]
            },
            closeDialog() {
                this.$emit('close')
                this.selectedUnusedFields = []
            },
            save() {
                this.$emit('save', this.selectedUnusedFields)
            }
        }
    })
